import { BaseResponseDto } from '@/models/dtos/baseReponseDto'
import { EndpointsAdmin } from '@/admin/services/_endpoints.admin'
import axios from 'axios'
import { TemplateDto } from '@/models/dtos/templateDto'

export abstract class TemplateAdminService {
  static async get(id: string): Promise<TemplateDto> {
    const result = await axios
      .get<BaseResponseDto<TemplateDto>>(EndpointsAdmin.template.get, {
        params: {
          id
        }
      })

    if (!result?.data?.dto) throw new Error('Cannot get template')

    return result.data.dto
  }

  static async getAll(): Promise<TemplateDto[]> {
    const result = await axios
      .get<BaseResponseDto<TemplateDto[]>>(EndpointsAdmin.template.getAll)

    if (!result.data.dto) return []

    return result.data.dto
  }

  static async add(template: TemplateDto): Promise<string> {
    const result = await axios
      .post<BaseResponseDto<string>>(EndpointsAdmin.template.add, template)

    return result.data.dto!
  }

  static async edit(template: TemplateDto): Promise<void> {
    await axios
      .put<BaseResponseDto<any>>(EndpointsAdmin.template.edit, template)
  }

  static async remove(id: string): Promise<void> {
    await axios
      .delete<BaseResponseDto<any>>(EndpointsAdmin.template.remove, {
        params: {
          id
        }
      })
  }
}
